interface SessionSelectorState {
  auth?: {
    session?: {
      expires?: string | null;
    } | null;
  };
}

const getSessionExpiresSelector = (state: SessionSelectorState) => state.auth?.session?.expires || null;

export default getSessionExpiresSelector;
